<div class="px-wrapper pc-txt pt-3 pb-3 shadow-sm">
    <div class="font-weight-bold" [innerHtml]="title | trustAsHtml"></div>
    <div [innerHtml]="text | trustAsHtml"></div>
</div>
